var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9887 0.920741L18.8459 19.7775C18.8049 20.0149 18.674 20.199 18.453 20.33C18.3384 20.3954 18.2116 20.4282 18.0724 20.4282C17.9824 20.4282 17.8842 20.4077 17.7778 20.3668L12.2165 18.0956L9.24561 20.7172C9.09829 20.9055 8.89777 20.9996 8.64406 20.9996C8.53766 20.9996 8.44763 20.9832 8.37397 20.9505C8.21847 20.8932 8.09366 20.797 7.99954 20.662C7.90542 20.5269 7.85836 20.3776 7.85836 20.2139V16.9294L14.0891 9.05206L5.34166 15.2843L0.492426 13.2955C0.189603 13.1809 0.0259173 12.9559 0.00136409 12.6203C-0.0150047 12.2929 0.115944 12.0515 0.394214 11.896L20.8224 0.110489C20.9452 0.0368293 21.0761 0 21.2152 0C21.3789 0 21.5262 0.0450136 21.6572 0.135042C21.9273 0.331468 22.0378 0.593365 21.9887 0.920741Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.669901911ebadc8d07a43d9c702284bb.svg";
export { ForwardRef as ReactComponent };